import React from "react";
import BrewGuide from "../components/BrewGuide";
import Journey from "../components/Journey";

function Blog() {
  return (
    <main className="bg-cream pt-24">
      <section className="bg-espresso px-5 py-16 text-center text-cream md:px-8">
        <p className="eyebrow text-gold-soft">Learn</p>
        <h1 className="mt-3 font-display text-4xl md:text-5xl">Brew Better Cups</h1>
        <p className="mx-auto mt-4 max-w-xl text-cream/75">
          Recipes, freshness tips, and the farm-to-cup journey behind every bag of KBL Coffee.
        </p>
      </section>
      <BrewGuide />
      <Journey />
    </main>
  );
}

export default Blog;
